import PageProgress from "./SliderNavigation.component";

export default PageProgress;
